import { render, staticRenderFns } from "./TitleTreatment.vue?vue&type=template&id=da21905a&scoped=true&"
import script from "./TitleTreatment.vue?vue&type=script&lang=js&"
export * from "./TitleTreatment.vue?vue&type=script&lang=js&"
import style0 from "./TitleTreatment.vue?vue&type=style&index=0&id=da21905a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da21905a",
  null
  
)

export default component.exports